// extracted by mini-css-extract-plugin
export default {"notifications":"style_notifications__cvT1y"};